'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var browsers = exports.browsers = require('../../data/browsers');


//////////////////
// WEBPACK FOOTER
// ./~/caniuse-lite/dist/unpacker/browsers.js
// module id = 121
// module chunks = 79718873386587